var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgPingpongVa = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18
}, props), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", {
  id: "pingpongVa_svg__a",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /* @__PURE__ */ React.createElement("stop", {
  offset: 0,
  stopColor: "#1e9ee6"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#3674c4"
}))), /* @__PURE__ */ React.createElement("g", {
  "data-name": "\\u7EC4 5684"
}, /* @__PURE__ */ React.createElement("path", {
  "data-name": "\\u51CF\\u53BB 18",
  d: "M18 18H0V0h18v18ZM5.963 1.127v14.862a.89.89 0 0 0 1.516.629.9.9 0 0 0 .257-.629v-3.732h1.506a2.989 2.989 0 0 0 2.988-2.982V4.112a2.991 2.991 0 0 0-2.988-2.985Zm3.169 9.387h-1.4V2.885h1.4a1.377 1.377 0 0 1 1.377 1.373v4.883a1.377 1.377 0 0 1-1.377 1.373Z",
  fill: "url(#pingpongVa_svg__a)"
})));
export { SvgPingpongVa as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iLjUiIHgyPSIuNSIgeTI9IjEiIGdyYWRpZW50VW5pdHM9Im9iamVjdEJvdW5kaW5nQm94Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMxZTllZTYiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMzNjc0YzQiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48ZyBkYXRhLW5hbWU9Iue7hCA1Njg0Ij48cGF0aCBkYXRhLW5hbWU9IuWHj+WOuyAxOCIgZD0iTTE4IDE4SDBWMGgxOHYxOFpNNS45NjMgMS4xMjd2MTQuODYyYS44OS44OSAwIDAgMCAxLjUxNi42MjkuOS45IDAgMCAwIC4yNTctLjYyOXYtMy43MzJoMS41MDZhMi45ODkgMi45ODkgMCAwIDAgMi45ODgtMi45ODJWNC4xMTJhMi45OTEgMi45OTEgMCAwIDAtMi45ODgtMi45ODVabTMuMTY5IDkuMzg3aC0xLjRWMi44ODVoMS40YTEuMzc3IDEuMzc3IDAgMCAxIDEuMzc3IDEuMzczdjQuODgzYTEuMzc3IDEuMzc3IDAgMCAxLTEuMzc3IDEuMzczWiIgZmlsbD0idXJsKCNhKSIvPjwvZz48L3N2Zz4=";
